export default "/images/slash.svg?40c1c466364449c6421e3b613b4f3166";